"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OSRType = void 0;
var OSRType;
(function (OSRType) {
    OSRType["Default"] = "default";
    OSRType["DesktopOnly"] = "desktopOnly";
    OSRType["InGameOnly"] = "inGameOnly";
})(OSRType = exports.OSRType || (exports.OSRType = {}));
//# sourceMappingURL=osr_window_type.js.map